import * as _ from "underscore";

import { WS_NAME } from "./wsDefs";
import { getWsByName } from "./wsHelpers";

import {
  initLoanFileWs,
  initWsByName,
  initWsById,
  wsCreate,
  wsImport,
  wsFetch,
  wsUpdate,
  wsDeleteFromField,
} from "./actions";

export const mapStateToProps = (state, ownProps) => ({
  worksheets: _.where(state.worksheetEditor.worksheets, {
    appId: ownProps.appId,
  }),
});

export const mapDispatchToProps = (dispatch, ownProps) => ({
  actions: {
    initLoanFileWs: wsId => dispatch(initLoanFileWs(ownProps.appId, wsId)),
    initWsByName: wsName => dispatch(initWsByName(ownProps.appId, wsName)),
    initWsById: (wsName, wsId) => dispatch(initWsById(ownProps.appId, wsName, wsId)),
    wsCreate: wsName => dispatch(wsCreate(ownProps.appId, wsName)),
    wsImport: (wsName, wsId) => dispatch(wsImport(ownProps.appId, wsName, wsId)),
    wsFetch: (wsName, wsId) => dispatch(wsFetch(ownProps.appId, wsName, wsId)),
    wsUpdate: (wsId, wsName, version, field, value) =>
      dispatch(wsUpdate(ownProps.appId, wsName, wsId, version, field, value)),
    wsDeleteFromField: (wsId, version, field, index) =>
      dispatch(wsDeleteFromField(ownProps.appId, wsId, version, field, index)),
  },
});

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const finalProps = Object.assign({}, ownProps, stateProps, dispatchProps);

  // NOTE: jjw: when bootstrapping (first creating the loan_file worksheet),
  // it's possible to get into a state where loan_file has been created but
  // its id is not yet set on the loan app (since the loan app doesn't reload
  // automatically when changed)... the modification below guarantees that the
  // loan_file id will flow through on any render where the worksheet exists
  // (we can remove this once we guarantee that the loan app's always current)

  const loanFileWs = getWsByName(stateProps.worksheets, WS_NAME.LOAN_FILE);
  if (loanFileWs) {
    return {
      ...finalProps,
      loanFileWsId: loanFileWs.id,
    };
  }

  return finalProps;
};
